const appConfigType={
    LOAD_ENV_PROPERTY_SUCCESS: "LOAD_ENV_PROPERTY_SUCCESS",
    LOAD_ENV_PROPERTY_ERROR: "LOAD_ENV_PROPERTY_ERROR",
};
export default appConfigType;